import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'
import clsx from 'clsx'
import DownTriangleIcon from '../../../assets/Icons/DownTriangleIcon'

// Styles for this component.
const styles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    '&.Mui-expanded': {
      margin: '0',
      '&:before': {
        opacity: 1,
      },
      '& .MuiAccordionSummary-root': {
        backgroundColor: '#fff', // no highlight on hover when expanded
      },
    },
    '&:before': {
      // line dividers
      // display: 'none',
      backgroundColor:
        theme.extras.variables.colors.faintBorder,
    },
  },
  summary: {
    margin: '12px 0px',
    '&.Mui-expanded': {
      margin: '12px 0px',
    },
  },
  summaryContainer: {
    padding: theme.spacing(0.5, 1, 0.5, 0),
    flexDirection: 'row-reverse',
    minHeight: 'unset',
    '&.Mui-expanded': {
      minHeight: 'unset',
    },
  },
  expandIcon: {
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
    width: '20px',
    color: theme.extras.variables.colors.black,
    transform: 'rotate(-90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(0)',
    },
  },
  details: {
    borderBottom: theme.extras.variables.colors.faintBorder,
    padding: theme.spacing(0, 3, 0.5, 4),
  },
}))

const Accordion = ({
  id,
  summary,
  details,
  expanded,
  handleChange,
  className,
}) => {
  const classes = styles()

  return (
    <MuiAccordion
      id={id} // id to scroll to
      className={clsx(className, 'ddk-accordion')}
      classes={{ root: classes.root }}
      expanded={expanded}
      onChange={handleChange}
      square={true}
      key={id}
    >
      <AccordionSummary
        classes={{
          root: classes.summaryContainer,
          content: classes.summary,
          expandIcon: classes.expandIcon,
        }}
        expandIcon={<DownTriangleIcon />}
        // expandIcon={<IconButton>◤</IconButton>}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.details }}>
        {details}
      </AccordionDetails>
    </MuiAccordion>
  )
}

export default Accordion
